import React, { Component } from "react";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { PURCHASEIRQCompareView } from "../views/PURCHASEIRQCompareView";
import EditableDataContainer from "../containers/EditableDataContainer";
import { refinanceComparePageValidationSchema } from "../util/comparePageValidationSchema";
import { connect } from "react-redux";
import { mapPageToProps } from "../util/mapPageToProps";
import { LoadingIndicator } from "../atoms/LoadingIndicator";
import { FastTrackView } from "../views/FastTrackView";
import { processQuoteResult } from "../util/fetch/processQuoteResult";
import { withToastContext } from "../util/withToastContext";
import { isDataValidForRefinance } from "../util/fetch/isDataValidForRefinance";
import { isPlannedClosingDateLessThanThirteenDaysAway } from "../util/fetch/isPlannedClosingDateLessThanThirteenDaysAway";
import { getParametizedQuoteEndpoint } from "../util/fetch/getParametizedQuoteEndpoint";
import { LookingToContext } from "../context/LookingToContext";
import { CountyLimitsContext } from "../context/CountyLimitsContext";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqComparePage extends Component {
  static contextType = CountyLimitsContext;

  constructor() {
    super();
    this.state = {
      quotes: null,
      insufficientData: null,
      lookingTo: "Refinance",
    };
    this.runQuotesQuery = this.runQuotesQuery.bind(this);
    this.getPageData = this.getPageData.bind(this);
  }

  componentDidMount() {
    if (!isDataValidForRefinance(this.props.data)) {
      this.setState({ insufficientData: true });
      if (
        isPlannedClosingDateLessThanThirteenDaysAway(
          this.props.data.plannedClosingDate
        )
      ) {
        this.props.toastContext.openToast({
          message:
            "You must select a planned closing date more than 15 days away.",
        });
      }
      this.context.fetchCountyLimits();
      return;
    }
    this.getPageData();
  }

  getPageData = async () => {
    await this.context.fetchCountyLimits();
    this.runQuotesQuery(
      this.props.data.lookingTo ?? "Refinance",
      this.props.data
    );
  };

  runQuotesQuery = (lookingTo, data) => {
    this.setState({ lookingTo });
    const parametizedQuoteEndpoint = getParametizedQuoteEndpoint(
      lookingTo,
      data
    );
    return processQuoteResult.call(this, parametizedQuoteEndpoint);
  };

  render() {
    const { countyLimits } = this.context;

    if (countyLimits === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching page data..." />
        </div>
      );
    }

    if (this.state.insufficientData === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching loan options..." />
        </div>
      );
    }

    if (this.state.insufficientData === true) {
      return (
        <div className="page-wrapper">
          <LookingToContext.Provider value={this.state.lookingTo}>
            <EditableDataContainer
              id="refinanceIrq"
              mutateRedux="always"
              validationSchema={refinanceComparePageValidationSchema}
              isStep
            >
              <FastTrackView
                runQuotesQuery={this.runQuotesQuery}
                content={contentMap.RefinanceIrqComparePage}
                navigationsAway={customNavigationMap.RefinanceIrqComparePage}
              />
            </EditableDataContainer>
          </LookingToContext.Provider>
        </div>
      );
    }

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <LookingToContext.Provider value={this.state.lookingTo}>
          <EditableDataContainer
            id="refinanceIrq"
            mutateRedux="always"
            isStep
            validationSchema={refinanceComparePageValidationSchema}
          >
            <PURCHASEIRQCompareView
              runQuotesQuery={this.runQuotesQuery}
              quotes={this.state.quotes}
              content={contentMap.RefinanceIrqComparePage}
              navigationsAway={customNavigationMap.RefinanceIrqComparePage}
            />
          </EditableDataContainer>
        </LookingToContext.Provider>
      </div>
    );
  }
}

export default connect(mapPageToProps("refinanceIrq"))(
  withToastContext(withRouterUtilities(RefinanceIrqComparePage))
);
